import { C_OveraskData, FreeBetCondition, LineItem, SmartLineItem, TicketModeEnum } from "@ticket/models";

export interface ApplicableBonus {
  BonusId: string;
  PlayerBonusId: string;
  Applied: boolean;
  BonusDescription: string;
  AppliedAmount: number;
  PendingAmount: number;
  BonusTransactionId: string;
  Priority: number;
  BonusType: number;
}

export interface RaceLineItem {
  Amount: number;
  AmountLocal: number;
  CanBeEachWay: boolean;
  downOdd: boolean;
  EventDate: string;
  EventHasHandicap: boolean;
  EventName: string;
  GameBetTypeAvailability: number;
  GameId: string;
  GameLocked: boolean;
  GameName: string;
  GameSpecialOddsValue: string;
  GreyhoundHorseBetType: unknown;
  GreyhoundHorses: boolean;
  Handicap: boolean;
  Index: number;
  IsBanked: boolean;
  IsBet: boolean;
  IsLive: boolean;
  ItemId?: number;
  LeagueId?: string;
  LineErrorMessages: string[];
  LineErrors: string[];
  LineItemStatus: number;
  LiveStatus: boolean;
  LocationId?: string;
  Name: string;
  NodeId: string;
  NotAvailable: boolean;
  Odd: number;
  Paddock: string;
  Participants: RaceParticipant[];
  PendingCheck: boolean;
  PipelineExecutionResult: number;
  Place: number;
  ResultName: string;
  ResultsNr: string;
  Selected: boolean;
  SpecialOddsValue: string;
  SportHandle: string;
  TicketNumber: string;
  TotalPotentialWin?: number;
  upOdd: boolean;
}

export interface FreebetInstance {
  Amount: number;
  BonusOfferId: number;
  Conditions: FreeBetCondition[];
  ExpirationDate: unknown;
  IsRedeemable: boolean;
  VoucherCode: string;
  Name: string;
  Validation: {
    systems: boolean;
    singles: boolean;
  };
}

export interface RaceParticipant {
  OpenPrice: boolean;
  Id: string;
  Place: number;
  Name: string;
}

export interface ApplicableAccaBonus {
  BonusId: number;
  maxBonusRate: number;
  BonusAmount: number;
}

export interface StakeGroups {
  Singles: {
    totalAmount?: number;
    totalPotentialWin?: number;
  };
  Accumulator: {
    totalAmount?: number;
    totalPotentialWin?: number;
    systemId?: number;
    bonus?: unknown;
  };
  System: {
    totalAmount?: number;
    totalPotentialWin?: number;
    systemId?: number;
    possibleSystems?: systemData[];
    bonus?: unknown;
    selectedGroup?: string;
  };
}

export interface systemData {
  canBeEachWay: boolean;
  numberOfBetWays: number;
  numberOfEachWayBetWays: number;
  systemId: number;
  systemType: string;
  text?: string;
  groupName: string;
}

export interface TicketBetslipModel {
  ApplicableAccaBonus: ApplicableAccaBonus;
  BetType: number;
  BonusChecked: unknown;
  Bonuses?: ApplicableBonus[];
  CombinationMulticast: RaceLineItem[];
  FreebetInstance?: FreebetInstance;
  FreeBetVoucherId?: string;
  hasChangesInOdds: boolean;
  keepSelection: boolean;
  LanguageCode: string;
  LineItems: LineItem[];
  MaxCombinations?: number;
  MaxMult?: number;
  mode: TicketModeEnum;
  MultisingleError?: string;
  NumberOfBanks?: number;
  NumberOfResults?: number;
  Odd: number;
  OrderBonusMessages: string[];
  OrderErrorMessages: string[];
  OrderErrors: unknown;
  OrderFormId?: string;
  OveraskCloseBet?: unknown;
  OveraskInfo: C_OveraskData;
  processing?: boolean;
  SingleStakeLimits?: number;
  SmartLineItems: SmartLineItem[];
  StakeGroups: StakeGroups;
  StraightM: RaceLineItem[];
  SystemSelected: systemData;
  SystemStakeLimits?: number;
  SystemType: number;
  TicketNumber: string;
  Total: number;
  TotalBets: number;
  TotalLocal: string;
  TotalPotentialWin?: number;
  TotalPotentialWinWithoutBoost?: number;
}

// export interface BetslipTicket {
//   ApplicableAccaBonus: ApplicableAccaBonus;
//   BetType: number;
//   BonusChecked: unknown;
//   Bonuses?: ApplicableBonus[];
//   CombinationMulticast: RaceLineItem[];
//   FreebetInstance?: FreebetInstance;
//   FreeBetVoucherId?: string;
//   HasChangesInOdds: boolean;
//   IsAcceptBettingOdds?: boolean;
//   keepSelection: boolean;
//   LanguageCode: string;
//   LineItems: LineItem[];
//   MaxCombinations?: number;
//   MaxMult?: number;
//   mode: TicketModeEnum;
//   MultisingleError?: string;
//   NumberOfBanks?: number;
//   NumberOfResults?: number;
//   Odd: number;
//   OrderBonusMessages: string[];
//   OrderErrorMessages: string[];
//   OrderErrors: unknown;
//   OrderFormId?: string;
//   OveraskCloseBet?: unknown;
//   OveraskInfo: C_OveraskData;
//   processing?: boolean;
//   SingleStakeLimits?: number;
//   SmartLineItems: SmartLineItem[];
//   StakeGroups: StakeGroups;
//   StraightM: RaceLineItem[];
//   SystemSelected: systemData;
//   SystemStakeLimits?: number;
//   SystemType: number;
//   TicketNumber: string;
//   Total: number;
//   TotalBets: number;
//   TotalLocal: string;
//   TotalPotentialWin?: number;
//   TotalPotentialWinWithoutBoost?: number;
// }
